import DeleteProfile from './components/DeleteProfile';
import { profileApi } from './api/profile.api';

export const { useGetProfileQuery, useLazyGetProfileQuery } = profileApi;

export { DeleteProfile, profileApi };
